import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (err) {
      // Not authenticated is expected here; log only unexpected errors
      if (err?.response && err.response.status !== 401) {
        console.error("Auth refresh error:", err);
      }
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    // Skip /me check if returning from OAuth (AuthCallback handles it)
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    (async () => {
      await refresh();
      setLoading(false);
    })();
  }, [refresh]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.error("Logout failed:", err); }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, refresh, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
